<template>
	<div class="animated fadeIn">
		<h1 class="text-light">充電裝置-ApplePay Test</h1>

		<b-row>

			<b-col xl="12" lg="12" md="12" v-if="show_device_occupied">
		        <b-card no-body>
		          <div slot="header">
		            <i class="fa fa-exclamation-triangle"></i> 裝置使用中
		          </div>
		          <b-card-body>
		            <h1 class="text-warning w-100 text-center">
		            	裝置目前使用中，請等前位使用者結束後再次掃描QR Code <i class="fa fa-qrcode"></i>
		            </h1>
		          </b-card-body>
		        </b-card >
		    </b-col>

			<b-col xl="12" lg="12" md="12" v-if="show_init_spinning">
        <b-card no-body>
          <div slot="header">
            <i class="fa fa-anchor"></i> 系統初始化 <i class="fa fa-qrcode"></i>
          </div>
          <b-card-body class="text-center" v-if="show_scan_qrcode_msg">
          	<div class="w-100"><b-button class="mx-auto" variant="info" @click="openQrCodeScanner()">開啟QR Code掃瞄器</b-button></div>
            <i class="fa fa-qrcode" style="font-size:15rem; padding:0px;margin:0px;"></i>
          </b-card-body>
          <b-card-body v-else>
            <div class="sk-wave">
              <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
            </div>
            <p v-if="count_down" class="text-muted w-100 text-center">系統倒數：{{count_down}}</p>
          </b-card-body>
        </b-card >
		  </b-col>

      <b-col xl="12" lg="12" md="12" v-if="show_device_disconnected">
        <b-card no-body>
          <div slot="header">
            <i class="fa fa-anchor"></i> 裝置離線 <i class="fa fa-frown-o"></i>
          </div>
          <b-card-body class="text-center">
            <h3>目前裝置離線，請使用Line客服回報</h3>
            <h6 class="text-center"><a href="https://lin.ee/B0X4IJ8"><img height="54" width="54" src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/LINE_logo.svg/768px-LINE_logo.svg.png"></a></h6>
          </b-card-body>
        </b-card >
      </b-col>
            
      <b-col xl="12" lg="12" md="12" v-if="show_mqtt">
		        <b-card no-body class="transparent-bg main-body">
		          
		          <!-- <b-img v-if="!mqtt_value.value3" src="img/innoknight/battery.empty.png" fluid alt="InnoKnight"/> -->
		          <!-- <b-img v-if="mqtt_value.value3" src="img/innoknight/battery.charging.png" fluid alt="InnoKnight"/> -->

              <i class="fa fa-battery-empty battery-icon" v-if="!mqtt_value.value3"></i>
              <i class="fa fa fa-battery-half battery-icon-charging" v-if="mqtt_value.value3"></i>

              <b-card-body class="text-center action-btn-container">
                <b-button v-if="mqtt_value.value3" class="col-sm-12" size="lg" variant="danger" @click="toggleValue3(0)" :disabled="disable_btns">
                  <span class="lg-icon-btn"> <i class="fa fa-stop-circle"></i> 停止充電</span>
                </b-button>
                <b-button variant="success" v-else class="col-sm-12" size="lg" @click="toggleValue3(1)" :disabled="disable_btns" :style="'background-color:none;'">
                  <span class="lg-icon-btn"> <i class="fa fa-play-circle"></i> 開始充電</span>
                </b-button>
              </b-card-body>

		          <div v-if="device_record" class="status-li">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/location.icon.png" width="30" fluid alt="InnoKnight"/>
		          		</b-col>
		          		<b-col class="li-text">{{device_record.name || '創玖科技'}}</b-col>
		          	</b-row>
		          </div>

              <div v-if="device_record && !device_record.charge_first" class="status-li">
                <b-row>
                  <b-col class="li-icon">
                    <b-img src="img/innoknight/money.icon.png" width="30" fluid alt="InnoKnight"/>
                  </b-col>
                  <b-col v-if="device_record.enable_peak_time" class="li-text">
                    <div>離峰單價：{{$math.round(device_record.price, 2) + '點/度'}}</div>
		          			<div>尖峰單價：{{$math.round(device_record.price_peak, 2) + '點/度'}}</div>
                    <div>尖峰時間：{{device_record.peak_start_time + '~' + device_record.peak_end_time}}</div>
                    <div><p><small> (1 點 = 1.15 NTD) </small></p></div>
		          		</b-col>
                  <b-col v-if="!device_record.enable_peak_time" class="li-text">
                    <div>離峰單價：{{$math.round(device_record.price, 2) + '點/度'}}</div>
                    <div><p><small> (1 點 = 1.15 NTD) </small></p></div>
		          		</b-col>
                  <!--<b-col class="li-text">{{'單價：' + $math.round(device_record.price, 2) + '點/度'}}</b-col>-->
                </b-row>
              </div>

              <div v-if="device_record && device_record.charge_first" class="status-li">
                <b-row>
                  <b-col class="li-icon">
                    <b-img src="img/innoknight/money.icon.png" width="30" fluid alt="InnoKnight"/>
                  </b-col>
                  <b-col class="li-text">
                    {{'單次充電：$' + device_record.charge_value + '元/次'}}
                    ({{ $math.round(device_record.charge_value/1.15, 2) + '點/次'}})
                  </b-col>
                </b-row>
              </div>

		          <div v-if="!mqtt_value.value3" class="status-li">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/status.icon.png" width="30" fluid alt="InnoKnight"/>
		          		</b-col>
		          		<b-col class="li-text">請點擊開始充電</b-col>
		          	</b-row>
		          </div>

		          <div v-if="mqtt_value.value3" class="status-li">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/status.icon.png" width="30" fluid alt="InnoKnight"/> 
		          		</b-col>
		          		<b-col class="li-text">充電中</b-col>
		          	</b-row>
		          </div>

		          <div v-if="mqtt_value.value3" class="status-li hidden">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/calendar.icon.png" width="30" fluid alt="InnoKnight"/>
		          		</b-col>
		          		<b-col class="li-text">
		          			<div class="hidden">消耗度數：{{mqtt_value.value1|kwh}}</div>
		          			<div class="hidden">總耗度數：{{mqtt_value.value2|kwh}}</div>
		          		</b-col>
		          	</b-row>
		          </div>

		          <div v-if="current_used_watts !== null" class="status-li">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/calendar.icon.png" width="30" fluid alt="InnoKnight"/>
		          		</b-col>
		          		<b-col class="li-text">
                    <div>瞬間瓦數：{{mqtt_value.value1|kw}}</div>
		          			<div v-if="current_used_watts > 0">離峰度數：{{current_used_watts|kwh}}</div>
                    <div v-if="current_used_watts_peak > 0">尖峰度數：{{current_used_watts_peak|kwh}}</div>
                    <div>總度數：  {{$math.round(total_used_watts,2)|kwh}}</div>
		          			<div>累積時間：{{current_used_time|timeStr}}</div>
		          		</b-col>
		          	</b-row>
		          </div>

		          <div v-if="total_price !== null" class="status-li">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/money.icon.png" width="30" fluid alt="InnoKnight"/>
		          		</b-col>
		          		<b-col class="li-text">
		          			<div v-if="total_pay > 0">離峰消耗點數：{{ $math.round(total_pay, 2) }}點</div>
                    <div v-if="total_pay_peak > 0">尖峰消耗點數：{{ $math.round(total_pay_peak, 2) }}點</div>
                    <div>總消耗點數：{{ $math.round(total_price, 2) }}點</div>
		          		</b-col>
		          	</b-row>
		          </div>

		          <div v-if="record" class="status-li hidden">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/calendar.icon.png" width="30" fluid alt="InnoKnight"/>
		          		</b-col>
		          		<b-col class="li-text">
		          			<div>前次消耗度數：{{record.used_watts|kwh}}</div>
		          			<div>前次消耗時間：{{record.interval}}小時</div>
		          		</b-col>
		          	</b-row>
		          </div>

		          <div v-if="record" class="status-li hidden">
		          	<b-row>
		          		<b-col class="li-icon">
		          			<b-img src="img/innoknight/money.icon.png" width="30" fluid alt="InnoKnight"/>
		          		</b-col>
		          		<b-col class="li-text">
		          			<div>前次費用：{{ $math.round((record.used_watts)*(device_record.price ? device_record.price : price), 2) }}點 ({{record.used_watts|kwh}})</div>
		          		</b-col>
		          	</b-row>
		          </div>

		          <div v-if="mqtt_value.value3" class="text-left text-light hidden">
		          	<div>消耗度數：{{mqtt_value.value1|kwh}}</div>
		          	<div class="hidden">總耗度數：{{mqtt_value.value2|kwh}}</div>
		          </div>

		          <div v-if="record" class="text-center hidden">
		          	<li>前次充電消耗度數：{{record.used_watts|kwh}}</li>
		          	<li>前次充電消耗時間：{{record.interval}}小時</li>
		          </div>
		        </b-card >
		    </b-col>
            
        <b-col xl="12" lg="12" md="12" v-if="show_account_balace">
		        <b-card no-body>
		          <div slot="header">
		            <i class="fa fa-balance-scale"></i> 帳戶&nbsp;
                <b-button v-if="isDemo =='NO'" style="margin: 0 5px;" class="pull-right" size="sm" variant="success" @click="popGrouponModal()"><i class="fa fa-ticket"></i> 優惠卷</b-button>&nbsp;
                <b-button v-if="isDemo =='NO'" class="pull-right" size="sm" variant="primary" @click="popTopUpModal()"><i class="fa fa-plus"></i> 加值</b-button>&nbsp;
                <b-button v-if="isDemo =='NO'" style="margin: 0 5px; color: white;" class="pull-right" size="sm" variant="info" @click="popCreditCardModal()"><i class="fa fa-credit-card"></i> 綁定信用卡</b-button>&nbsp;
		          </div>
		          <b-card-body>
                <span class="fixed-leading"><i class="fa fa-usd"></i></span>帳戶餘額：{{balance|round}}點<br>
                <span class="fixed-leading"><i class="fa fa-diamond"></i></span>紅利點數：{{bonus|roundAbs}}點<br>
                <div v-if="available_cards && available_cards.length">
                  <table border="0" cellpadding="3">
                    <tr>
                      <th colspan="6" align="center">
                        <i class="fa fa-credit-card"></i> 已綁定信用卡
                      </th>
                    </tr>
                    <tr>
                      <th>卡號</th>
                      <th>日期</th>
                      <th class="text-center">操作</th>
                    </tr>
                    <tr v-for="(card, index) in available_cards" :key="card.id">
                      <td>
                        <span v-if="card.is_main" class="text-primary"><i class="fa fa-check"></i></span>
                        <span v-else class="text-danger"><i class="fa fa-times"></i></span>
                        {{`xxxx-xxxx-xxxx-${card.last4}`}}
                      </td>
                      <td>{{card.validate.toString().substr(2) + '/' + card.validate.toString().substr(0,2)}}</td>
                      <td>
                        <span v-if="card.is_main" class="text-primary pull-right">（扣款用卡）</span>
                        <b-button style="margin: 0 5px;"
                                  class="pull-right"
                                  size="sm"
                                  variant="primary"
                                  v-if="!card.is_main"
                                  @click="setCreditCard(card.id, card.last4, 'primary')">
                                    <i class="fa fa-check"></i> 設定為扣款卡
                        </b-button>
                        <b-button style="margin: 0 5px;"
                                  class="pull-right"
                                  size="sm"
                                  variant="danger"
                                  @click="setCreditCard(card.id, card.last4, 'delete')">
                                    <i class="fa fa-times"></i> 刪除
                        </b-button>
                      </td>
                    </tr>
                  </table>
                </div>
		          </b-card-body>
		        </b-card >
		    </b-col>

        <b-col xl="12" lg="12" md="12">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-volume-control-phone"></i> LINE 客服&nbsp;
              </div>
              <b-card-body>
                <h6 class="text-center"><a href="https://lin.ee/B0X4IJ8"><img height="54" width="54" src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/LINE_logo.svg/768px-LINE_logo.svg.png"></a></h6>
              </b-card-body>
            </b-card >
        </b-col>


        <b-col xl="12" lg="12" md="12">
            <b-card no-body>
              <div slot="header">
                <i class="fas fa-ad"></i> 更多服務項目&nbsp;
              </div>
              <b-card-body>
                <h6 class="text-left">1. 充電站共同營運</h6>
                <h6 class="text-left">2. 社區專設一戶申請與 EMS 系統</h6><br><br>
                <h6 class="text-left">   服務電話: 03-5775036</h6>
                <h6 class="text-left">   電子郵件: system@innoknight.com</h6>
              </b-card-body>
            </b-card >
        </b-col>
		


			<b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
				<b-card :no-body="true">
			        <b-card-body v-if="show_init_msg" class="p-0 clearfix">
			            <i class="fa fa-cogs bg-info p-4 font-2xl mr-3 float-left"></i>
			            <div class="h6 text-primary mb-0 pt-3">服務器</div>
			            <div class="text-uppercase font-weight-bold font-xs text-success">就位</div>
			            <div class="font-xs text-dark hidden">最近連線：{{mqtt_value.timestamp|htime}}</div>
			        </b-card-body>
		        </b-card>
		    </b-col>
		   	<b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
	    		<b-card :no-body="true">
			        <b-card-body v-if="show_mqtt" class="p-0 clearfix">
			            <i class="fa fa-tachometer bg-info p-4 font-2xl mr-3 float-left"></i>
			            <div class="h6 text-primary mb-0 pt-3">智慧電表</div>
			            <div class="text-uppercase font-weight-bold font-xs text-success">就位({{mqtt_value.deviceid}})</div>
			            <div class="font-xs text-dark hidden">代號：{{mqtt_value.deviceid}}</div>
			        </b-card-body>
		        </b-card>
	        </b-col>

	        <b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
	    		<b-card :no-body="true">
			        <b-card-body v-if="show_mqtt" class="p-0 clearfix">
			            <i class="fa fa-pause-circle-o bg-info p-4 font-2xl mr-3 float-left"></i>
			            <div class="h6 text-primary mb-0 pt-3">電表資料</div>
			            <div class="font-xs text-dark hidden">總耗功率：{{mqtt_value.value2|kwh}}</div>
			            <div class="font-xs text-dark">狀態：<span :class="mqtt_value.value3?'text-success':'text-warning'">{{mqtt_value.value3?'啟動':'關閉'}}</span></div>
			        </b-card-body>
		        </b-card>
	        </b-col>

	        <b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
	    		<b-card :no-body="true">
			        <b-card-body v-if="show_mqtt" class="p-0 clearfix">
			            <i class="fa fa-clock-o bg-info p-4 font-2xl mr-3 float-left"></i>
			            <div class="h6 text-primary mb-0 pt-3">充電資料</div>
			            <div class="font-xs text-dark">開始時間：{{start_time|htime}}</div>
			            <div class="font-xs text-dark">結束時間：{{end_time|htime}}</div>
			        </b-card-body>
		        </b-card>
	        </b-col>

		</b-row>

		<b-modal title="QR Code掃瞄器" v-model="showErrorModal" ok-title="確定" :ok-only="true" :hide-footer="true" @hidden="hideScanner()">
	    	<b-alert :show="showErrorModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>
	    	<!-- <canvas id="qrcode-window" v-if="show_qrcode_canvas"></canvas> -->
        <!-- <video id="qrcode-video" playsinline muted></video> -->
        <video
          v-show="showErrorModal"
          id="qrvideo"
          autoplay
          muted
          loop
          playsinline
          webkit-playsinline
          style="border: 1px solid gray; width: 100%; height: 100%"></video>
        <p class="text-primary">{{qrcode_string}}</p>
		</b-modal>

		<b-modal title="負載偵測" v-model="showLoadDetectorModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
			<h3>負載偵測</h3>
	    	<b-alert :show="showLoadDetectorModal" variant="success"><i class="fa fa-exclamation-triangle"></i>{{detectorMsg}}</b-alert>
		</b-modal>
        
        <b-modal title="金流連線處理中" v-model="showCashFlowLoadingModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
			<h5>金流連線中...</h5>
            <b-img src="img/innoknight/blueWeb.png" fluid alt="InnoKnight"></b-img>
		</b-modal>
        
    <b-modal title="連線處理中" v-model="showDemoLoadingModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
			<h5>展示裝置初始化中....</h5>
      <div class="sk-wave">
        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
      </div>
		</b-modal>
        
    <b-modal title="金流連線處理中" v-model="showCashCheckOutModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
			<h5>結算費用</h5>
            <span class="fixed-leading"><i class="fa fa-usd"></i></span>帳戶餘額：{{balance}}<br>
            <span class="fixed-leading"><i class="fa fa-diamond"></i></span>紅利點數：{{bonus}}<br>
            <hr>
            <div v-if="current_used_watts > 0">離峰度數：{{current_used_watts|kwh}}</div>
            <div v-if="current_used_watts_peak > 0">尖峰度數：{{current_used_watts_peak|kwh}}</div>
            <div v-if="total_pay > 0">離峰費用：{{($math.round(total_pay, 2))}}點</div>
            <div v-if="total_pay_peak > 0">尖峰費用：{{($math.round(total_pay_peak, 2))}}點</div>
            <div>消耗時間：{{current_used_time|timeStr}}</div>
            <div>目前總費用：{{($math.round(total_price, 2))}}點 <!--&nbsp;&nbsp;<b-form-checkbox id="deductBonus" v-model="deduct_bonus" value="1" unchecked-value="0" @change="onDeductClick()">使用紅利折抵</b-form-checkbox>--></div>
            <hr>
            <div>
            	<span class="hidden">實際需要支付費用：{{amount_to_pay()|round}}元</span>
                <i class="fa fa-check-square-o" aria-hidden="true"></i><span class="text-primary" > 折抵後點數：<i class="fa fa-usd"></i>{{after_credits|round}}</span><br>
                <i class="fa fa-check-square-o" aria-hidden="true"></i><span class="text-danger" > 折抵後紅利：<i class="fa fa-diamond"></i>{{final_bonus|round}}</span>
            </div>
            <div class="row">
                <div v-if="showCashCheckOutProcessing" class="col-xs-12 col-md-12 text-center">
                    <b-button variant="warning" class="top-up-btn"><i class="fa fa-spinner"></i>結帳中，請稍候</b-button>
                </div>
                <div class="col-xs-6 col-md-6 text-center" v-if="!showCashCheckOutProcessing">
                    <b-button variant="primary" class="top-up-btn" @click="doCheckOut(1)">結束充電</b-button>
                </div>
                <div class="col-xs-6 col-md-6 text-center" v-if="!showCashCheckOutProcessing">
                    <b-button variant="" class="top-up-btn" @click="doCheckOut(0)">繼續充電</b-button>
                </div>
            </div>
		</b-modal>

    <b-modal title="充電樁錯誤處理中" v-model="showMqttErrorCheckOutModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true"> 
        <div class="row">
            <div class="col-xs-12 col-md-12 text-center">
                <b-alert variant="warning" class="col-xs-12 col-md-12 text-center" :show="true"><i class="fa fa-exclamation-triangle"></i>{{mqtt_error_code_detail}}</b-alert>
            </div>
            <div class="col-xs-12 col-md-12 text-center">
                <b-button variant="warning" class="col-xs-12 col-md-12 text-center"><i class="fa fa-spinner"></i>系統處理中，請稍候</b-button>
            </div>
        </div>
		</b-modal>

    <b-modal
      title="套用優惠代碼"
      v-model="showCouponModal"
      :hide-footer="true"
      :hide-header="false">
      <h5>請輸入優惠代碼</h5>
            <div>
              <b-form-input
                ref="couponsn"
                class="text-center"
                autocomplete="off"
                autofocus
                v-model="couponsn"
                type="number"
                style="font-size: 3rem; height: 6.6rem;"/>
            </div>
            <div class="row">
              <div v-if="checkCouponProcessing" class="col-xs-12 col-md-12 text-center">
                  <b-button variant="warning" class="top-up-btn"><i class="fa fa-spinner"></i>查核中，請稍候</b-button>
              </div>
              <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCouponProcessing">
                <b-button variant="primary" class="top-up-btn" @click="checkCoupon(1)">驗證優惠代碼</b-button>
              </div>
            </div>
    </b-modal>

    <b-modal
      title="請選擇您的方案"
      v-model="showPaymentModal"
      :hide-footer="true"
      :hide-header="false">
      <b-alert variant="warning"
               class="text-center"
               :show="true">
        <i class="fa fa-exclamation-triangle"></i>
        {{showTopMsg}}
      </b-alert>
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
          <b-button variant="info" class="top-up-btn" @click="popCreditCardModal()" style="color: white">綁定信用卡</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
          <b-button variant="primary" class="top-up-btn" @click="popTopUpModal()">加值</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
          <b-button variant="warning" class="top-up-btn" @click="showPaymentModal=false">取消</b-button>
        </div>
      </div>

    </b-modal>

    <b-modal
      title="本裝置有設定單次充電價格"
      v-model="showChargeFirstModal"
      :hide-footer="true"
      :hide-header="false">
      <b-alert variant="warning"
               class="text-center"
               :show="true">
        <i class="fa fa-exclamation-triangle"></i>
        本裝置有設定單次充電價格：${{device_record.charge_value}}元/次({{$math.round(device_record.charge_value/1.15,2)}}點/次)，在您點擊確認充電後，您的帳號將會預先扣款
      </b-alert>
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center mt-3">
          <b-button variant="info" class="top-up-btn" @click="chargeFirst()" style="color: white">確認充電</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3">
          <b-button variant="warning" class="top-up-btn" @click="chargeFirst(1)">取消</b-button>
        </div>
        <div v-if="prepayChargeMsg" class="col-xs-12 col-md-12 text-center text-danger">
          {{prepayChargeMsg}}
        </div>
      </div>

    </b-modal>

    <b-modal
      title="綁定信用卡"
      v-model="showCreditCardModal"
      :hide-footer="true"
      :hide-header="false">
      <h5>請輸入信用卡資料</h5>
        <div>
          <div v-if="showUpdateUserEmail">
            <h5>驗證用Email：</h5>
            <b-form-input
              ref="cardemail"
              class="text-center"
              autocomplete="off"
              autofocus
              v-model="cardemail"
              type="email"
              maxlength="63"
              style="font-size: 1.5rem; height: 5.4rem;"/>
            <p class="text-danger" v-if="cardemailinvalid">請確認驗證用Email</p>  
          </div>
          <h5>卡號：</h5>
          <b-form-input
            ref="cardno"
            class="text-center"
            autocomplete="off"
            autofocus
            v-model="cardno"
            type="text"
            pattern="\d*"
            maxlength="16"
            style="font-size: 1.5rem; height: 5.4rem;"/>
          <p class="text-danger" v-if="cardnoinvalid">請確認信用卡號碼</p>
          <h5>有效時間（月份年份，無需分隔號，如：0324）：</h5>
          <b-form-input
            ref="carddate"
            class="text-center"
            autocomplete="off"
            autofocus
            v-model="carddate"
            type="text"
            pattern="\d*"
            maxlength="4"
            style="font-size: 1.5rem; height: 5.4rem;"/>
          <p class="text-danger" v-if="carddateinvalid">請確認有效時間</p>
          <h5>卡片背面驗證碼：</h5>
          <b-form-input
            ref="cardcvs"
            class="text-center"
            autocomplete="off"
            autofocus
            v-model="cardcvs"
            type="text"
            pattern="\d*"
            maxlength="5"
            style="font-size: 1.5rem; height: 5.4rem;"/>
          <p class="text-danger" v-if="cardcvsinvalid">請確認驗證碼</p>
        </div>
        <div style="font-size: 1.5rem; color: #E69623;">
          系統會向卡片扣款1元用於驗證有效性，驗證完畢後將會取消扣款
        </div>
        <div class="row">
          <div v-if="checkCreditCartProcessing" class="col-xs-12 col-md-12 text-center">
              <b-button variant="warning" class="top-up-btn"><i class="fa fa-spinner"></i>查核中，請稍候</b-button>
          </div>
          <div v-if="creditCartCheckingResult" class="col-xs-12 col-md-12 text-center" :class="creditCartCheckingSuccess ? 'text-primary' : 'text-danger'">
            {{creditCartCheckingResult}}
          </div>
          <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
            <b-button variant="primary" class="top-up-btn" @click="checkCreditCard()">儲存</b-button>
          </div>
        </div>
    </b-modal>

    <b-modal title="付款方式" v-model="showSelectPaymentModal" :hide-footer="true" :hide-header="false" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <b-alert :show="showTopUpModal" variant="warning" class="text-center"><i class="fa fa-exclamation-triangle"></i>請選擇付款方式</b-alert>
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center">
          <b-button variant="light" class="select-payment-btn" @click="setPaymentMethod(1)">信用卡付款</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center" v-if="isApplePayOkay">
          <b-button variant="light" class="select-payment-btn" @click="setPaymentMethod(2)"><b-img class="select-payment-img" src="img/innoknight/Apple_Pay_logo.svg" alt="Apple Pay"></b-img></b-button>
        </div>
        <!--<div class="col-xs-12 col-md-12 text-center">
          <b-button variant="light" class="select-payment-btn" @click="setPaymentMethod(3)"><b-img class="select-payment-img" src="img/innoknight/LINE-Pay_h_W238_n.png" alt="Line Pay"></b-img></b-button>
        </div>  -->
        <div class="col-xs-12 col-md-12 text-center">
          <b-button variant="light" class="select-payment-btn" @click="setPaymentMethod(4)"><b-img class="select-payment-img" src="img/innoknight/Google_Pay_Logo_(2020).svg" alt="Google Pay"></b-img></b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center">
          <b-button variant="light" class="select-payment-btn" @click="setPaymentMethod(5)"><b-img class="select-payment-img" src="img/innoknight/Samsung_Pay_Logo.svg" alt="Samsung Pay"></b-img></b-button>
        </div>
      </div>
    </b-modal>
        
    <b-modal title="加值" v-model="showTopUpModal" :hide-footer="true" :hide-header="false" :no-close-on-esc="true" :no-close-on-backdrop="true">
			<b-alert :show="showTopUpModal" variant="warning" class="text-center"><i class="fa fa-exclamation-triangle"></i>{{showTopMsg}}</b-alert>
            <div>
              <h5>買受人Email（收取電子發票用，若不填寫則自動捐贈）</h5>
              <b-form-input
                ref="buyeremail"
                class="text-center"
                autocomplete="off"
                v-model="buyeremail"
                type="email"
                style="font-size: 1.2rem; height: 3rem;"/>
              <h5>買受人名稱（選填）</h5>
              <b-form-input
                ref="buyername"
                class="text-center"
                autocomplete="off"
                v-model="buyername"
                type="text"
                style="font-size: 1.2rem; height: 3rem;"/>
              <h5>發票統一編號（選填）</h5>
              <b-form-input
                ref="buyerubn"
                class="text-center"
                autocomplete="off"
                v-model="buyerubn"
                type="number"
                style="font-size: 1.2rem; height: 3rem;"/>
            </div>
            <h5>付款方式</h5>
            <div class="row">
              <div class="col-md-12 col-xs-12 text-center">
                <b-button v-if="payment_method===0" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()">-- 請選擇付款方式 --</b-button>
                <b-button v-if="payment_method===1" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()">信用卡付款</b-button>
                <b-button v-if="payment_method===2&&isApplePayOkay" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img center class="select-payment-img" src="img/innoknight/Apple_Pay_logo.svg" alt="Apple Pay"></b-img></b-button>
                <b-button v-if="payment_method===3" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img center class="select-payment-img" src="img/innoknight/LINE-Pay_h_W238_n.png" alt="Line Pay"></b-img></b-button>
                <b-button v-if="payment_method===4" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img center class="select-payment-img" src="img/innoknight/Google_Pay_Logo_(2020).svg" alt="Google Pay"></b-img></b-button>
                <b-button v-if="payment_method===5" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img center class="select-payment-img" src="img/innoknight/Samsung_Pay_Logo.svg" alt="Samsung Pay"></b-img></b-button>
              </div>
            </div>
            <h4>1點NTD${{unit_price}}元（含稅），請選擇加值點數：</h4>
            <blockquote>
                <i class="fa fa-plus"></i>加值{{Math.round(unit_price*2400)}}元送<span class="text-danger">30點</span>紅利<br>
                <i class="fa fa-plus"></i>加值{{Math.round(unit_price*3000)}}元送<span class="text-danger">60點</span>紅利
            </blockquote>
            <!--<div class="row mb-3 text-center" v-if="isApplePayOkay">
              <div class="col-6 text-right">
                <input
                  :placeholder="`ApplePay欲加值點數，須大於等於${minApplePayAmount}點`"
                  type="number"
                  v-model="applePayAmount"
                  maxlength="5"
                  class="text-center"
                  autocomplete="off"
                  :min="minApplePayAmount"
                  style="font-size: 1.2rem; height: 3rem; width: 80%; display: inline-block;"/>
                  <span style="font-size: 1.2rem;"> 點</span>
              </div>
              <span class="apple-pay-amount col-6 text-left">加值金額：{{Math.round(applePayAmount*1.15)}}元</span>
              <div class="col-md-12 col-xs-12 text-center">
                <button
                  type="button"
                  id="btnApplePay"
                  class="apple-pay-button apple-pay-button-white top-up-btn text-center"
                  lang="tw"
                  @click="initApplePay"></button>
              </div>
            </div> -->
            <div class="row">
                <!-- <div class="col-md-12 col-xs-12 text-center">
                    <b-button variant="" class="top-up-btn" @click="getTransactionForm(10)">加10點（$12元）</b-button>
                </div> -->
                <div class="col-md-12 col-xs-12 text-center">
                    <b-button
                      v-if="device_record.charge_value && ($math.round(unit_price*100) >= device_record.charge_value * 1.5)"
                      variant="" class="top-up-btn" @click="doPaymentProcess(100)">加100點(${{Math.round(unit_price*100)}}元)</b-button>
                    <b-button
                      v-if="!device_record.charge_value"
                      variant="" class="top-up-btn" @click="doPaymentProcess(100)">加100點(${{Math.round(unit_price*100)}}元)</b-button>
                </div>
                <div class="col-md-12 col-xs-12 text-center">
                    <b-button
                      v-if="device_record.charge_value && ($math.round(unit_price*300) >= device_record.charge_value * 1.5)"
                      variant="" class="top-up-btn" @click="doPaymentProcess(300)">加300點(${{Math.round(unit_price*300)}}元)</b-button>
                    <b-button
                      v-if="!device_record.charge_value"
                      variant="" class="top-up-btn" @click="doPaymentProcess(300)">加300點(${{Math.round(unit_price*300)}}元)</b-button>
                </div>
                <div class="col-md-12 col-xs-12 text-center">
                    <b-button
                      v-if="device_record.charge_value && ($math.round(unit_price*600) >= device_record.charge_value * 1.5)"
                      variant="" class="top-up-btn" @click="doPaymentProcess(600)">加600點(${{Math.round(unit_price*600)}}元)</b-button>
                    <b-button
                      v-if="!device_record.charge_value"
                      variant="" class="top-up-btn" @click="doPaymentProcess(600)">加600點(${{Math.round(unit_price*600)}}元)</b-button>
                </div>
                <div class="col-md-12 col-xs-12 text-center">
                    <b-button
                      v-if="device_record.charge_value && ($math.round(unit_price*1200) >= device_record.charge_value * 1.5)"
                      variant="" class="top-up-btn" @click="doPaymentProcess(1200)">加1,200點(${{Math.round(unit_price*1200)}}元)</b-button>
                    <b-button
                      v-if="!device_record.charge_value"
                      variant="" class="top-up-btn" @click="doPaymentProcess(1200)">加1,200點(${{Math.round(unit_price*1200)}}元)</b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xs-12 text-center">
                    <b-button
                      v-if="device_record.charge_value && ($math.round(unit_price*2400) >= device_record.charge_value * 1.5)"
                      variant="primary" class="top-up-btn" @click="doPaymentProcess(2400)">加2,400點(${{Math.round(unit_price*2400)}}元)</b-button>
                    <b-button
                      v-if="!device_record.charge_value"
                      variant="primary" class="top-up-btn" @click="doPaymentProcess(2400)">加2,400點(${{Math.round(unit_price*2400)}}元)</b-button>
                </div>
                <div class="col-md-12 col-xs-12 text-center">
                    <b-button
                      v-if="device_record.charge_value && ($math.round(unit_price*3000) >= device_record.charge_value * 1.5)"
                      variant="primary" class="top-up-btn " @click="doPaymentProcess(3000)">加3,000點(${{Math.round(unit_price*3000)}}元)</b-button>
                    <b-button
                      v-if="!device_record.charge_value"
                      variant="primary" class="top-up-btn " @click="doPaymentProcess(3000)">加3,000點(${{Math.round(unit_price*3000)}}元)</b-button>
                </div>
            </div>
		</b-modal>

		<div class="hidden" id="tmp-form"></div>
	</div>
</template>
<script>
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import io from 'socket.io-client'
import moment from 'moment-timezone'
import _ from 'lodash'
import { BrowserQRCodeReader } from '@zxing/library';
import { isNull } from '../../public/js/browserMqtt'

const codeReader = new BrowserQRCodeReader();

let $socket  = null;
let scanner  = null;
let eventbus = config.eventbus;
let getUrlParameter = function getUrlParameter(url) {
  let sPageURL = url.substring(url.indexOf('?')+1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i,
      rlt={};

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      rlt[sParameterName[0]] = sParameterName[1];
  }

  return rlt;
};//eo getUrlParameter

let get_latest_charging_record = function(app){
	app.$jsonp(`${config.mqtt_root}/get_latest_charging_record`, {
		user_id:   encodeURIComponent(app.$state.$get('user').uuid),
		device_id: encodeURIComponent(app.uuid),
		keyset: 'mqtt',
		token: app.$state.$get('user').token
	}).then((charging_record) => {
		// console.info('get_latest_charging_record:', charging_record);
		app.charging_record = charging_record.record;

		if(charging_record.flag){
			app.show_device_occupied = true;
			app.show_mqtt            = false;
			app.show_init_spinning   = false;
			return;
		}

		if(charging_record.success && charging_record.record){
			app.start_time      = charging_record.record.start_time;
			app.end_time        = charging_record.record.end_time;

			if(charging_record.record.status === 'end'){
				app.record            = {};
				app.record.used_watts = charging_record.record.used_watts;
				app.record.interval   = Math.round(charging_record.record.interval/3600);
			} else {
        //console.info('[get_latest_charging_record] charging_record.charging_info: ', charging_record.charging_info);
        if(charging_record.charging_info) {
          app.current_used_watts = charging_record.charging_info.used_watts;
          app.current_used_watts_peak = charging_record.charging_info.used_watts_peak;
          app.total_used_watts = (charging_record.charging_info.used_watts * 1) + (charging_record.charging_info.used_watts_peak * 1);
          app.total_pay = charging_record.charging_info.total_pay;
          app.total_pay_peak = charging_record.charging_info.total_pay_peak;
          app.total_price = charging_record.charging_info.total_pay + charging_record.charging_info.total_pay_peak;
        }
      }
		}
	});
};//eo get_latest_charging_record

let get_user_latest_charging_record = function(app){

  if (!app.$state.$get('user')) {
    window.location.href = '/';
    return;
  }

	app.$jsonp(`${config.mqtt_root}/get_user_latest_charging_record`, {
		user_id: encodeURIComponent(app.$state.$get('user').uuid),
		keyset: 'mqtt',
		token: app.$state.$get('user').token
	}).then((charging_record) => {
		
        // console.info('get_user_latest_charging_record:', charging_record);
        
        if(charging_record.success && charging_record.record && charging_record.record.status === 'start'){
            // app.charging_record = charging_record.record;
                
            let uuid = config.encrypt(''+charging_record.record.deviceid, config.ffkey, config.ffiv);
            
            app.$state.$set('uuid', uuid);
            app.uuid = uuid;

            let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
                uuid: encodeURIComponent(uuid)
            });

            window.location = href;
            location.reload();
        }
	});
};//eo get_user_latest_charging_record

let get_balance = function(app){
    
    let user = app.$state.$get('user');
    
    app.$jsonp(`${config.mqtt_root}/read_balance`, {
        device_id: app.uuid ? app.uuid : 0,
        user_id: user.uuid,
        token: user.token,
    }).then((result) => {
            
        // console.info('read_balance:', result);
        
        if(result.success){
            app.balance = parseInt(result.user.credits);
            app.bonus = parseInt(result.user.bonus);
            
            user.credits = result.user.credits;
            user.bonus = result.user.bonus;
            app.isDemo = result.user.demo;

            if (!user.email && result.user.email) {
              user.email = result.user.email;
            }

            if ((!app.buyeremail || app.buyeremail.indexOf('@') === -1) && result.user.email && !app.showTopUpModal) {
              app.buyeremail = result.user.email;
            }

            // console.info(`app.buyername: ${app.buyername}, result.user.name: ${result.user.name}`);

            if ((!app.buyername || app.buyername === '匿名使用者') && result.user.name && !app.showTopUpModal) {
              app.buyername = result.user.name;
              // console.info(`app.buyername: ${app.buyername}, result.user.name: ${result.user.name}`);
            }

            if (!app.buyerubn && result.user.invoiceno && !app.showTopUpModal) {
              app.buyerubn = result.user.invoiceno;
            }

            if (result.user.name && result.user.name !== '匿名使用者') {
              user.name = result.user.name;
              user.username = result.user.name;
              jQuery('#username-placeholder').html(user.username);
            }

            // console.info('available_cards - 0: ', app.available_cards, result.user.cards);
            if (result.user.cards && (app.available_cards.length != result.user.cards.length)) {
              // console.info('available_cards: ', app.available_cards);
              app.available_cards = result.user.cards;
            } else if (!result.user.cards) {
              app.available_cards = [];
            }

            //console.info('[get_balance] result.charging_info: ', result.charging_info);
            if(result.charging_info) {
              app.current_used_watts = result.charging_info.used_watts;
              app.current_used_watts_peak = result.charging_info.used_watts_peak;
              app.total_used_watts = (result.charging_info.used_watts * 1) + (result.charging_info.used_watts_peak * 1);
              app.total_pay = result.charging_info.total_pay;
              app.total_pay_peak = result.charging_info.total_pay_peak;
              app.total_price = result.charging_info.total_pay + result.charging_info.total_pay_peak;
            }

            // console.info(`user: `, user);
            
            if(app.balance > 0 || app.available_cards.length > 0){
                user.card_id = 'YES';
                app.showTopUpModal = false;
            } else if (app.device_record.charge_value
                       && app.balance < app.device_record.charge_value
                       && app.available_cards.length === 0) {
                app.showPaymentModal = true;
                // console.info('#1...');
                app.showTopMsg = `您目前沒有足夠的餘額(${app.balance+app.bonus}點)，請進行加值或綁定信用卡`;
            } else {
                app.showPaymentModal = true;
                // console.info('#2...');
                app.showTopMsg = `您目前沒有足夠的餘額(${app.balance+app.bonus}點)，請進行加值或綁定信用卡`;
            }
            
            app.$state.$set('user', user);//update user
        }
    });
};

let get_device_info = function(app, device_id){
    
  let user = app.$state.$get('user');
  
  if(!user || !device_id){
      return;
  }
  
  return app.$jsonp(`${config.mqtt_root}/get_device_info`, {
    user_id: user.uuid,
    device_id,
    keyset: 'mqtt',
    token: app.$state.$get('user').token
  }).then((device_record) => {
    if(device_record.success){
      app.device_record = device_record.record; 
      app.uuid = device_id;
      // console.log('device_record.record: ', device_record.record);
    }
  });
};

let get_device_info_n_login = function(app, device_id){
    
    app.showDemoLoadingModal = true;
    
    return app.$jsonp(`${config.mqtt_root}/get_device_info_plain`, {
        device_id,
        keyset: 'mqtt'
    }).then((device_record) => {
        if(device_record.success){
            app.device_record = device_record.record; 
            
            if(device_record.record.user){
              app.$state.$set('user', device_record.record.user);
              console.info('reload - 7');
              window.location.reload();
            }
            
        } else {
            app.showError({message:'請先登入系統後再掃描QR code'});
            app.$state.$set('device_id', device_id);

            let _vcc = setTimeout(() => {
              app.$router.push('/');
              clearTimeout(_vcc);
            }, 1500);
        }
        // console.info('app.device_record:', app.device_record);
    }).catch((error) => {
        app.showError({message:'無法透過QR code讀取裝置資料#2'});
        console.error('cannot read device:', error);
        
        let _vcc = setTimeout(() => {
            app.$router.push('/');
            clearTimeout(_vcc);
        }, 1500);
    });
    
};

let user_id_token_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`user_id_token_check no user`);
    return;
  }
  //console.info(`user_id_token_check user.uuid: ${user.uuid}`);

  let action = `${config.mqtt_root}/user_id_token_check`;
  fetch(action, {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
    user_id: user.uuid
    })
  }).then(res => res.json()).then(result => {
    if(result.success === false){  
      //console.info(`user_id_token_check fail`); 
      app.showError({
        title: '服務端辨識錯誤',
        message: '無法辨識使用者資訊，請重新登入'
      });
      app.$state.$del('user');
      app.$router.push('/');
    }
  }).catch(error => {
    app.showError({
      title: '服務端辨識錯誤',
      message: '無法辨識使用者資訊，請重新登入'
    });
    app.$state.$del('user');
    app.$router.push('/');
  });
};

let cards_validate_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`cards_validate_check no user`);
    return;
  }
  //console.info(`cards_validate_check user.uuid: ${user.uuid}`);

  return app.$jsonp(`${config.mqtt_root}/cards_validate_check`, {
  user_id: user.uuid
  }).then((validate_check) => {
    if(validate_check.success === true && validate_check.cards_found_invalid === true){  
      app.showPaymentModal = true;
      // console.info('#2...');
      app.showTopMsg = `信用卡已失效，請重新綁定信用卡`;
    }
  });
};

export default {
	name: 'Device',
	notifications,
	data(){
    const minApplePayAmount = 100;
    const user = this.$state.$get('user');
    // console.info('user: ', user);

    const buyername = user && user.name ? user.name : '';
    const buyeremail = user && user.email ? user.email : '';

		return {
      unit_price: 1.15,
      isDemo: 'NO',
			show_qrcode_canvas: false,
			show_device_occupied: false,
			show_scan_qrcode_msg: false,
      show_account_balace: true,
			record: null,
			start_time:'',
			end_time:'',
			count_down:0,
			disable_btns: false,
			show_init_spinning: true,
			show_init_msg: false,
			show_mqtt: false,
			uuid: null,
			device_id: null,
			device_record: {},
			showErrorModal: false,
			showLoadDetectorModal: false,
      force_shutdown_detector: false,
      showTopUpModal: false,
      showSelectPaymentModal: false,
      showCashFlowLoadingModal: false,
      showCashCheckOutModal: false,
      showMqttErrorCheckOutModal: false,
      showCashCheckOutProcessing: false,
      showDemoLoadingModal: false,
      showCouponModal: false,
      showCreditCardModal: false,
      showPaymentModal: false,
      showChargeFirstModal: false,
      checkCouponProcessing: false,
      checkCreditCartProcessing: false,
      showTopMsg: '',
			errorMsg: '',
			detectorMsg: '',
			mqtt_value: {},
      mqtt_error_code: 0,
      mqtt_error_code_detail: '',
			current_used_watts: 0,
      current_used_watts_peak: 0,
      total_used_watts: 0,
      total_price: 0,
      total_pay: 0,
      total_pay_peak: 0,
			current_used_time: null,
			charging_record: null,
      balance: 0,
      bonus: 0,
      deduct_bonus: 1,
      after_credits: 0,
      final_bonus: 0,
      current_bonus: 0,
      qrcode_string: '',
      price: 7,
			_cc: null,
			_lecc: null,
      cameraDevices: [],
      couponsn: '',
      buyerubn: '',
      buyername,
      buyeremail,
      isApplePayOkay: false,
      applePayAmount: minApplePayAmount,
      minApplePayAmount,
      cardno: '',
      carddate: '',
      cardcvs: '',
      cardemail: '',
      cardnoinvalid: false,
      carddateinvalid: false,
      cardcvsinvalid: false,
      cardemailinvalid: false,
      creditCartCheckingResult: null,
      creditCartCheckingSuccess: false,
      showUpdateUserEmail: false,
      available_cards: [],
      prepayChargeMsg: null,
      chargeBtnClicked: false,
      show_device_disconnected: false,
      stopRetry: false,
      payment_method: 0,
		}
	},//eo data
  created(){
		let app = this;

		app.$on('qrcodeDetected', function(result){
			// console.info('qr result:', result);
			
      app.$emit('reveived-qrcode', result);
			app.show_qrcode_canvas = false; 
			app.showErrorModal     = false;

			let params = getUrlParameter(result);
            
      // console.info('params:', params);

			if(params && params.uuid){
				app.uuid = decodeURIComponent(params.uuid);
				app.$state.$set('uuid', app.uuid);
        
        //Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
        let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
					uuid: app.uuid
				});

				// console.info('href:', href);

				window.location = href;

				location.reload();
			}
		});

		/*if(location.hash){
			//fetch Device record
			let url_params = getUrlParameter(location.hash); 

			if(url_params.uuid){
				get_device_info(app, url_params.uuid);
			}
		}*/

		// console.info('location:', );
	},
	updated(){
		// console.info('updated...');
	},
	mounted() {
		let app = this;

    jQuery('.app').css({background:'black'});

    eventbus.$on('start-qrcode-scanning', app.openQrCodeScanner);
    
    app.uuid = this.$route.query.uuid || null;

    // console.info('Okay...');

    // let __reload = setInterval(() => {
    //   if (this.mqtt_value.value3) {
    //     window.location.reload(true);
    //   }
    // }, 180000); // every 3 mins

    //Added force logout to avoid user.user_id encrypt with wrong iv/key when backend server restarting.
    user_id_token_check(app);
    
    let url_params = getUrlParameter(location.hash); 

		if(location.hash){
      if(url_params.uuid){
				get_device_info(app, url_params.uuid);
			} else {
        get_user_latest_charging_record(app);
      }
		}
        
		if(app.uuid === null){
			let predefinded_uuid = this.$state.$get('uuid');
			if(predefinded_uuid){
				app.uuid = predefinded_uuid;
				
				//write the UUID back to URL
				if(this.$route.query.uuid === undefined){
					location.href += '?' + jQuery.param({
						uuid: app.uuid
					});
				}
                
				this.$route.query.uuid = predefinded_uuid;
        get_device_info(app, predefinded_uuid);
			}
		}
        
    get_device_info(app, app.uuid);
        
    let user  = this.$state.$get('user');
		let token = user ? this.$state.$get('user').token : null;

    // console.info('login user:', user.credits);

    // console.info(`user.name: ${user.name}`);
    if (user && user.name && user.name !== '匿名使用者') {
      this.buyername = user.name;
    }

    if (user && user.email) {
      this.buyeremail = user.email;
    }

		if(!token){
            
      // console.info('url_params.uuid:', url_params.uuid);
            
      if(url_params.uuid){
          // console.info('url_params.uuid:', url_params.uuid);
          let get_device_info_promise = get_device_info_n_login(app, url_params.uuid, true);
          return;
      } else {
		    this.$state.$set('error', config.error.INVALID_USER);
      	this.$router.push('/');
      	return;
      }
		}
        
    cards_validate_check(app);
    get_balance(app);
    app.readBalance();
    
    if(!user.card_id){
        
        let credits = parseFloat(user.credits);
        
        if(credits.toFixed(2) === '0.00' && app.available_cards.length === 0){
            // app.showPaymentModal = true;
            // app.showTopMsg = '您目前尚未綁定信用卡，請透過下列儲值後綁定';
        }
    } else {
        app.show_account_balace = true;
        app.balance = parseInt(user.credits);
        app.bonus = parseInt(user.bonus);
    }

		if(app.uuid === null){
			
			app.errorMsg = '請掃描QR Code';
			app.show_scan_qrcode_msg = true;
			
			return;
		} else {
			app.show_scan_qrcode_msg = false;
		}
        
		let device_id = '';

		try{
			device_id = config.decrypt(app.uuid, config.ffkey, config.ffiv);
		} catch (exp) {
			this.showError({
				title: '系統錯誤',
				message: '無法辨識裝置'
			});

			this.$state.$del('user');
			this.$state.$del('uuid');
			this.$router.push('/');
			return;
		}

    get_latest_charging_record(app);
    
		app.device_id = device_id;

    var _check_mqtt_err_code = setInterval(() => {
      if (app.mqtt_error_code) {
        clearInterval(_check_mqtt_err_code);

        if(app.mqtt_error_code === 1000) {
          app.showLoadDetectorModal = false;
          app.force_shutdown_detector = true;

          //stop charging
          app.showMqttErrorCheckOutModal = true;
          let __stop_charging = setTimeout(() => {
            app.doCheckOut(1);
            clearTimeout(__stop_charging);
          }, 1000);
        }
        
        //reset error code to 0
        app.mqtt_error_code = 0;
      }
    }, 10000);

		$socket = io(config.socket_entry, {
      // 'force new connection': true,
      // transports: ['websocket'],
      upgrade: true,
      rememberUpgrade: true,
      forceNode: true,
    });

		// console.info('config.socket_entry:', config.socket_entry);
  	
		$socket.on('connect', () => {
			app.show_init_msg = true;
		});

		$socket.on('mqtt_socket_connected', (data) => {
			// console.info('mqtt_socket_connected:', data);
			// $socket.emit('mqtt_socket', {message:'from client'});

      let __rsf = setTimeout(() => {
        if (window.location.search
            && window.location.search.indexOf('retry') !== -1) {
          url_params = getUrlParameter(window.location.search); 
        }

        let retryCount = url_params.retry ? parseInt(url_params.retry) : 0;
        const togo = retryCount < 9 && !this.stopRetry;
        // console.info(`retryCount: ${retryCount}, this.stopRetry: ${this.stopRetry}, togo: ${togo}`);
        if (togo) {
          // console.info(window.location);
          retryCount++;
          window.location.href = `${window.location.origin}#/dashboard/showdevice?retry=${retryCount}`;
          setTimeout(() => {
            console.info('reload - 8');
            window.location.reload(true);
          }, 1200);
          // console.info(`${window.location.origin}?retry=${retryCount}&cache=${cache}`);
        }
      }, 5000);

      let __vcc = setTimeout(() => {
        $socket.emit('mqtt_socket', {
          type: 'mqtt-response',
          token: app.$state.$get('user').token,
          device_id: app.device_id,
          uuid: app.$state.$get('user').uuid,
        });

        let __vcc2 = setTimeout(() => {
          if (app.show_scan_qrcode_msg === false && app.show_mqtt === false) { // device disconnected
            app.show_init_spinning = false;
            app.show_device_disconnected = true;
          }
          clearTimeout(__vcc2);
        }, 60000);

        clearTimeout(__vcc);
      }, 3000);

      // let __vcc2 = setTimeout(() => {
      //   $socket.emit('mqtt_socket', {
      //     type: 'mqtt-response',
      //     token: app.$state.$get('user').token,
      //     device_id: app.device_id,
      //     uuid: app.$state.$get('user').uuid,
      //   });
      //   clearTimeout(__vcc2);
      // }, 15000);
		});

		let count_second = 60;
    let had_sent_query = false;

    // setInterval(() => {
    //   $socket.emit('hi');
    // }, 5000);
        
		$socket.on('mqtt_connected', (data) => {
            
      if(!had_sent_query){
        // console.info('send query...');
        $socket.emit('mqtt_socket', {
          type: 'mqtt-query',
          token: app.$state.$get('user').token,
          device_id: app.uuid,
          uuid: app.$state.$get('user').uuid,
        });
        had_sent_query = true;
      }
			
      // console.info('data received...');

			if(data.message.indexOf('&') !== -1){
				let parsed = config.mqtt_msg_parser(data.message);

        // console.info(`parsed.deviceid: ${parsed.deviceid}, device_id: ${device_id}`);
                
				if(parsed.deviceid === device_id){

          // console.info('device_id:', device_id, 'parsed: ', parsed);
          // console.info('device_id:', device_id);

					if(app._cc !== null){
						clearInterval(app._cc);
					}

					if(app.show_device_occupied){
						return;
					}

          // if (app.mqtt_value.value3 === 1 && parsed.value3 === 0) {
          //   console.info('reload - 1');
          //   window.location.reload(true);
          //   return;
          // }

          if(parsed.err_code) {
            app.mqtt_error_code = parseInt(parsed.err_code);
            if(app.mqtt_error_code === 1000) { //ErrorCode 1000 is OCPP server remote start transaction fail.
              app.mqtt_error_code_detail = `無法啟動充電樁(ErrorCode: ${app.mqtt_error_code})`; 
            } else {
              app.mqtt_error_code_detail = `未知錯誤(ErrorCode: ${app.mqtt_error_code})`; 
            }
          }

					app.show_init_spinning = false;
					app.mqtt_value         = parsed;
					app.show_mqtt          = true;
					app.disable_btns       = false;
          app.stopRetry          = true;
					
					if(app.charging_record && parsed.value3){
						//app.current_used_watts = parsed.value2 - app.charging_record.start_watts;
						app.current_used_time  = moment().tz(config.timezone).unix() - app.charging_record.start_time;
					}
				} else {
					
				}
			} else {

				let counter = 0;
				app.count_down = count_second;

				app._cc = setInterval(() => {

					if(app.show_mqtt){
						count_second = 999;
						clearInterval(app._cc);
						return;
					}

					// console.info('start counter:', counter);

					if(counter++ < count_second){
						app.count_down = count_second - counter;
					} else {

						clearInterval(app._cc);

						app.showError({
							message: '無法連結裝置，請稍後再試'
						});
					}

				}, 1000);
			}
		});
		
		$socket.on('update-log', (data) => {

			app.disable_btns = false;

			// app.mqtt_value.value3 = app.mqtt_value.value3 ? 0 : 1;

			if(!data.success){

				console.info('update-log:', data);

				let msg = '';
				switch(data.message) {
					case 'unable-to-start':
						msg = '無法開始充電，請稍後再試';
						break;
					case 'unable-to-finish':
						msg = '無法停止充電，請稍後再試';
						break;
					case 'no-previous-record':
						msg = '裝置目前使用中，請等待前一位使用者結束充電';
						break;
					case 'invalid-ownership':
						msg = '請等前一位使用者結束充電';
						break;
          case 'demo-check-error': //fixed user/device demo check not match issue.
            msg = '使用者權限錯誤，請重新登入';
            break;
          case 'overlap-in-3-mins':
            msg = '裝置已啟動，系統頁面即將重載更新，請稍候';
            setTimeout(() => {
              console.info('reload - 2');
              window.location.reload(true);
            }, 6000);

            break;
					case 'invalid-uuid':
						msg = '使用者ID錯誤';
						break;
				}

				app.showError({
					title: '系統回饋',
					message: msg
				});
			} else {
        console.info('update-log:', data);
        
				app.$jsonp(`${config.mqtt_root}/get_latest_charging_record`, {
					user_id:   encodeURIComponent(this.$state.$get('user').uuid),
					device_id: encodeURIComponent(app.uuid),
					keyset: 'mqtt',
					token: this.$state.$get('user').token
				}).then((charging_record) => {
					// console.info('charging_record:', charging_record);

					if(charging_record.success){
						app.start_time = charging_record.record.start_time;
						app.end_time   = charging_record.record.end_time;

						if(charging_record.record.status === 'end'){
							app.record            = {};
							app.record.used_watts = charging_record.record.used_watts;
              app.record.used_watts_peak = charging_record.record.used_watts_peak;
							app.record.interval   = Math.round(charging_record.record.interval/3600);
						}
					}
				});
			}
		});

    let _rvcc = setInterval(() => {
      get_latest_charging_record(app);
    }, 180000);
	},//eo mounted

	methods: {
    chargeFirst(cancel) {
      if (cancel === 1) {
        this.showChargeFirstModal = false;
        return;
      }

      this.showChargeFirstModal = false;
      this.toggleValue3(1, true);
      this.prepayChargeMsg = null;
    },
		toggleValue3(value, verified) {
			let app  = this;
      let user = this.$state.$get('user');

      if (app.disable_btns || app.chargeBtnClicked) {
        return false;
      }

      if (value === 1 && this.device_record.charge_first && !verified) {
        // this.showChargeFirstModal = true;
        this.chargeFirst();
        this.prepayChargeMsg = null;
        return;
      }

      if (value === 1 && this.device_record.charge_first) {
        let amount = this.$math.divide(this.device_record.charge_value,1.15);
        amount = this.$math.round(amount, 2);

        this.$jsonp(`${config.mqtt_root}/prepay`, {
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          device_id: encodeURIComponent(this.uuid),
          keyset: 'mqtt',
          token: this.$state.$get('user').token,
          amount,
        }).then((result) => {
          this.billId = null;
          // console.info('result: ', result);
          if (!result.success) {
            // this.toggleValue3(0);
            // this.prepayChargeMsg = result.message;

            $socket.emit('mqtt_socket', {
              type: 'mqtt-push',
              token: app.$state.$get('user').token,
              device_id: app.device_id,
              value: 0,
              watts: app.mqtt_value.value1,
              all_watts: app.mqtt_value.value2,
              uuid: app.$state.$get('user').uuid,
            });

            this.showError({
              title: '充電停止 - 付款失敗',
              message: result.message,
            });

            let __hvcc = setTimeout(() => {
              clearTimeout(__hvcc);
              this.showLoadDetectorModal = false;
            }, 1000);
          } else if (result.billId) {
            this.billId = result.billId;

            var __upbb = setTimeout(() => {
              $socket.emit('mqtt_socket', {
                type: 'update-charging',
                token: app.$state.$get('user').token,
                device_id: app.device_id,
                billId: result.billId,
                uuid: app.$state.$get('user').uuid,
              });
              clearTimeout(__upbb);
            }, 1000);
          }
        });
      }
      
      if(parseInt(value) === 0){
          // console.info('turn if off');
          app.showCashCheckOutModal = true;
          return;
      } else { //turn on
          let credits = parseInt(user.credits);
          
          if((isNaN(credits) || credits <= 0)
             && this.available_cards.length === 0){
              // console.info('#3...');
              app.showPaymentModal = true;
              app.showTopMsg = '您目前餘額不足，請先加值';
              return;
          } else if (this.device_record.charge_value
                     && credits < this.device_record.charge_value
                     && this.available_cards.length === 0) {
            // console.info('#4...', this.device_record.charge_value);
            app.showPaymentModal = true;
            app.showTopMsg = '您目前餘額不足或是沒有綁定信用卡，請先加值';
            return;
          }
      }

      let shutdown_detector = false;
      app.force_shutdown_detector = false;
      
      if (value === 1) {
        app.chargeBtnClicked = true;
        app.disable_btns = true;

        //reset error code to 0
        this.mqtt_error_code = 0; 
        this.mqtt_error_code_detail = '';

        var _checkvcc1 = setInterval(() => {
          if (!this.mqtt_value.value3) {
            this.showLoadDetectorModal = false;
            shutdown_detector = true;
            clearInterval(_checkvcc1);
          }
        }, 10000);
        

        let __rstcc1 = setTimeout(() => {
          app.chargeBtnClicked = false;
          clearTimeout(__rstcc1);
        }, 3000);
      }

			$socket.emit('mqtt_socket', {
				type: 'mqtt-push',
				token: app.$state.$get('user').token,
				device_id: app.device_id,
				value: value,
				watts: app.mqtt_value.value1,
				all_watts: app.mqtt_value.value2,
				uuid: app.$state.$get('user').uuid,
			});

			if(parseInt(value) === 0){//off
				app.end_time           = moment().tz(config.timezone).unix();
				app.current_used_watts = 0;
        app.current_used_watts_peak = 0;
        app.total_used_watts = 0;
        app.total_price = 0;
        app.total_pay = 0;
        app.total_pay_peak = 0;
				app.current_used_time  = 0;
			} else {
                
				app.start_time         = moment().tz(config.timezone).unix();
				app.current_used_watts = 0;
        app.current_used_watts_peak = 0;
        app.total_used_watts = 0;
        app.total_price = 0;
        app.total_pay = 0;
        app.total_pay_peak = 0;
				app.current_used_time  = 0;
				app.charging_record    = null;
				app.record             = null;

				let _cc = setTimeout(() => {
					get_latest_charging_record(app);
					clearTimeout(_cc);
				}, 1400);

        let _occ = setTimeout(() => {
					app.showLoadDetectorModal = true;
					clearTimeout(_occ);
				}, 800);

        let __vcc = setTimeout(() => {
          $socket.emit('mqtt_socket', {
            type: 'mqtt-response',
            token: app.$state.$get('user').token,
            device_id: app.device_id,
            uuid: app.$state.$get('user').uuid,
          });
          clearTimeout(__vcc);
        }, 10000);

        let __vcc2 = setTimeout(() => {
          $socket.emit('mqtt_socket', {
            type: 'mqtt-response',
            token: app.$state.$get('user').token,
            device_id: app.device_id,
            uuid: app.$state.$get('user').uuid,
          });
          clearTimeout(__vcc2);
        }, 35000);

        let __vcc3 = setTimeout(() => {
          $socket.emit('mqtt_socket', {
            type: 'mqtt-response',
            token: app.$state.$get('user').token,
            device_id: app.device_id,
            uuid: app.$state.$get('user').uuid,
          });
          clearTimeout(__vcc3);
        }, 75000);

        let __vcc4 = setTimeout(() => {
          $socket.emit('mqtt_socket', {
            type: 'mqtt-response',
            token: app.$state.$get('user').token,
            device_id: app.device_id,
            uuid: app.$state.$get('user').uuid,
          });
          clearTimeout(__vcc4);
        }, 95000);

        let __vcc5 = setTimeout(() => {
          $socket.emit('mqtt_socket', {
            type: 'mqtt-response',
            token: app.$state.$get('user').token,
            device_id: app.device_id,
            uuid: app.$state.$get('user').uuid,
          });
          clearTimeout(__vcc5);
        }, 150000);

        let __vcc6 = setTimeout(() => {
          $socket.emit('mqtt_socket', {
            type: 'mqtt-response',
            token: app.$state.$get('user').token,
            device_id: app.device_id,
            uuid: app.$state.$get('user').uuid,
          });
          clearTimeout(__vcc6);
        }, 270000);
                
        //start the load detector
        let timeout = 60*3;//seconds
        if(app.device_record.charging_timeout) {
          timeout = app.device_record.charging_timeout;
        }
        let has_sent = false;
				let _cc2 = setInterval(() => {

					// console.info('test: ', app.mqtt_value.value1);

					if(app.mqtt_value.value1 >= config.cutoff_threshold){
						clearInterval(_cc2);
						app.showLoadDetectorModal = false;

            if (this.available_cards.length && this.device_record.charge_value > 0) {

              // let amount = this.$math.divide(this.device_record.charge_value,1.15);
              // amount = this.$math.round(amount, 2);

              // this.$jsonp(`${config.mqtt_root}/prepay`, {
              //   user_id: encodeURIComponent(this.$state.$get('user').uuid),
              //   device_id: encodeURIComponent(this.uuid),
              //   keyset: 'mqtt',
              //   token: this.$state.$get('user').token,
              //   amount,
              // }).then((result) => {
              //   if (!result.success) {
              //     // this.toggleValue3(0);
              //     // this.prepayChargeMsg = result.message;

              //     $socket.emit('mqtt_socket', {
              //       type: 'mqtt-push',
              //       token: app.$state.$get('user').token,
              //       device_id: app.device_id,
              //       value: 0,
              //       watts: app.mqtt_value.value1,
              //       all_watts: app.mqtt_value.value2,
              //       uuid: app.$state.$get('user').uuid,
              //     });

              //     this.showError({
              //       title: '充電停止',
              //       message: result.message,
              //     });
              //   }
              // });
            }

					}
                    
          if(!has_sent){
            let _ctc = setTimeout(function(){
              $socket.emit('mqtt_socket', {
                type: 'mqtt-query',
                token: app.$state.$get('user').token,
                device_id: app.uuid,
                uuid: app.$state.$get('user').uuid,
              });
              clearTimeout(_ctc);
            }, 15000);
            has_sent = true;
          }

          if (shutdown_detector || app.force_shutdown_detector) {
            shutdown_detector = false;
            app.force_shutdown_detector = false;
            app.showLoadDetectorModal = false;
            clearInterval(_cc2);
            return;
          }
					
					if(timeout <= 0){
						// app.toggleValue3(0); //backend will take care of this
						clearInterval(_cc2);
            app.doCheckOut(1); //add this to improve backend detector not stop immediately.
						//app.showLoadDetectorModal = false;
            //setTimeout(() => {
            //  console.info('reload - 3');
            //  window.location.reload(true);
            //}, 1000);
					}

					app.detectorMsg = `請在${timeout}秒內接上需要充電裝置，若在${timeout}秒仍無接上，系統將自動關閉。目前消耗功率：${app.mqtt_value.value1}w；目標消耗功率：${config.cutoff_threshold}w`;
					timeout--;
				}, 1000);
			}

			// app.disable_btns = true;
		},//eo toggleValue3
		openQrCodeScanner() {
			let app = this;

			app.showErrorModal       = true
			app.show_scan_qrcode_msg = true;
			app.show_qrcode_canvas   = true;

			// let _ccc = setTimeout(() => {
			// 	clearTimeout(_ccc);
			// 	init_qrcode_reader(app);
			// }, 1000);

      codeReader
        .listVideoInputDevices()
        .then((videoInputDevices) => {
          let targetCamera;
          videoInputDevices.forEach((device) => {
            this.cameraDevices.push(`${device.label}, ${device.deviceId}`);
            if (this.camera === 'front' && device.label.toLowerCase().indexOf('front') !== -1) {
              targetCamera = device.deviceId;
              return false;
            }
            return true;
          });
          codeReader
            .decodeFromInputVideoDevice(undefined, 'qrvideo')
            .then(result => this.onDecode(result.text))
            .catch(err => {
              // this.showError({message:'無法偵測到QR code'});
              console.error(err)
            });
        })
        .catch(err => { 
          this.showError({message:'無法偵測到QR code，請使用其他瀏覽器試試'});
          console.error(err)
        });

		},//eo openQrCodeScanner
    onDecode(data) {
      this.$emit('qrcodeDetected', data);
      this.showSuccess({message:'QR code已偵測，裝置載入中...'});
    },
		hideScanner(){
			// let app = this;
			// app.getVideo().stop();
      if(scanner !== null && scanner.destroy){
          scanner.destroy();
          scanner = null;
      }
		},//eo hideScanner
    readBalance() {
      let app = this;
      let user = app.$state.$get('user');

      // console.info('read balance...');

      let timer = setTimeout(() => {
        // console.info('read balance started');        
        app.$jsonp(`${config.mqtt_root}/read_balance`, {
          device_id: app.uuid ? app.uuid : 0,
          user_id: app.$state.$get('user').uuid,
          token: app.$state.$get('user').token,
        }).then((result) => {
            if(result.success){
                app.balance = parseInt(result.user.credits);
                app.bonus = parseInt(result.user.bonus);
                
                user.credits = result.user.credits;
                user.bonus = result.user.bonus;
                app.isDemo = result.user.demo;

                if (!user.email && result.user.email) {
                  user.email = result.user.email;
                }

                if (!app.buyeremail && result.user.email && !app.showTopUpModal) {
                  app.buyeremail = result.user.email;
                }

                if (!app.buyername && result.user.name && !app.showTopUpModal) {
                  app.buyername = result.user.name;
                }

                if (!user.name && result.user.name) {
                  user.name = result.user.name;
                }

                if (!user.username && result.user.name) {
                  user.username = result.user.name;
                }

                if (result.user.cards && (app.available_cards.length != result.user.cards.length)) {
                  app.available_cards = result.user.cards;
                } else if (!result.user.cards) {
                  app.available_cards = [];
                }

                //console.info('[readBalance] result.charging_info: ', result.charging_info);
                if(result.charging_info) {
                  app.current_used_watts = result.charging_info.used_watts;
                  app.current_used_watts_peak = result.charging_info.used_watts_peak;
                  app.total_used_watts = (result.charging_info.used_watts * 1) + (result.charging_info.used_watts_peak * 1);
                  //console.info('[readBalance] total_used_watts: ', app.total_used_watts);
                  app.total_pay = result.charging_info.total_pay;
                  app.total_pay_peak = result.charging_info.total_pay_peak;
                  app.total_price = result.charging_info.total_pay + result.charging_info.total_pay_peak;
                }
                
                app.$state.$set('user', user);//update user

                app.readBalance();
            } else {
              //Added force reload to check user_id to fixed readBalance fail when user.user_id encrypt with wrong iv/key when backend server restarting.
              let reload_timer = setTimeout(() => {
                console.info('reload - readBalance fail');
                window.location.reload(true);
                clearTimeout(reload_timer);
              }, 1000);         
            }
        });
        clearTimeout(timer);
      }, 10000);
    }, // eo read balance
    doPaymentProcess(amount){
      if(this.payment_method === 0) { //User payment method not select.
        this.showError({message: '請選擇付款方式'});
        return;
      } else if(this.payment_method === 2) { //payment_method = 2 is ApplePay
        this.applePayAmount = amount;
        return this.initApplePay();
      } else if(this.payment_method === 3) {//payment_method = 3 is LinePay
        this.showTopUpModal = false;
        return;
      } else { //payment_method = others is NewebPay(include CreditCard/GooglePay/SamsungPay)
        return this.getTransactionForm(amount);
      }
    },
    getTransactionForm(amount){
      let app = this;
      let user = app.$state.$get('user');
      
      // if ( !this.buyername ) {
      //   this.$refs.buyername.focus();
      //   this.showError({message: '請填入發票買受人名稱'});
      //   return;
      // }

      // if ( !this.buyeremail ) {
      //   this.$refs.buyeremail.focus();
      //   this.showError({message: '請填入發票買受人Email'});
      //   return;
      // }

      if (this.buyerubn && this.buyerubn.length !== 8) {
        this.buyerubn = '';
        this.$refs.buyerubn.focus();
        this.showError({message: '請填入正確的統一編號'});
        return;
      }

      app.showCashFlowLoadingModal = true;
      app.showTopUpModal = false;

      amount *= app.unit_price;
      amount = Math.round(amount);
      
      jQuery.getJSON(`${config.mqtt_root}/render_transaction_form`, {
  		user_id: encodeURIComponent(app.$state.$get('user').uuid),
  		token: app.$state.$get('user').token,
          backurl: location.href,
          amount,
          callbackName: 'transactionJP',
          buyerubn: this.buyerubn,
          buyername: this.buyername,
          buyeremail: this.buyeremail,
  	  }).done(result => {
          console.info('render_transaction_form result:', result);
          
          if(result.auth && result.success){
              app.showSuccess({message:'加值成功'});
              
              app.$jsonp(`${config.mqtt_root}/read_balance`, {
                  device_id: app.uuid ? app.uuid : 0,
                  user_id: app.$state.$get('user').uuid,
                  token: app.$state.$get('user').token,
              }).then((result) => {
                      
                  // console.info('read_balance:', result);
                  
                  if(result.success){
                      app.balance = parseInt(result.user.credits);
                      app.bonus = parseInt(result.user.bonus);
                      
                      user.credits = result.user.credits;
                      user.bonus = result.user.bonus;
                      
                      app.$state.$set('user', user);//update user
                  }
              });
              app.showCashFlowLoadingModal = false;
              return;
          } else if(result.auth) {
              app.showCashFlowLoadingModal = false;
              app.showError({message:'加值失敗，請稍後再試'});
              return;
          }

          if(result.success){
          	let form = jQuery(result.form);
          	jQuery('#tmp-form').find('#transaction-form').remove();
              jQuery('#tmp-form').append(form).find('#transaction-form').submit();
              // jQuery('#tmp-form').append(form).find('#transaction-form');
          } else {
          	app.showError({message:'暫時無法加值，請稍後再試'});
          }
      });
        
    },//eo getTransactionForm

    popTopSelectPaymentModal(){
      this.showSelectPaymentModal = true;
      
    },//eo popTopSelectPaymentModal

    setPaymentMethod(method){
      this.payment_method = method;
      this.showSelectPaymentModal = false;
    },//eo setPaymentMethod
    
    popTopUpModal(){
      const user = this.$state.$get('user');
      this.showPaymentModal = false;

      if (user.username && user.username !== '匿名使用者') {
        this.buyername = user.username;
      }

      if (!this.buyeremail && user.email && user.email.indexOf('@') !== -1) {
        this.buyeremail = user.email;
      }

      if (this.buyeremail.indexOf('@') === -1) {
        this.buyeremail = '';
      }

      // console.info('popTopUpModal.user: ', user, ' ,this.buyeremail:', this.buyeremail);
      // console.info(this.$state.$get('user'));
      this.showTopMsg = '請點擊您要加值的方案';
      this.showTopUpModal = true;

      // console.info(window.ApplePaySession);
      if (window.ApplePaySession) {
        console.info('ApplePaySession is okay...');
        const merchantIdentifier = 'merchant.com.innoknight.iot';
        const promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
        promise.then((canMakePayments) => {
          if (canMakePayments) {
            console.info('ApplePay is good to go');
            this.isApplePayOkay = true;
          } else {
            this.isApplePayOkay = false;
          }
        });
      } else {
        this.isApplePayOkay = false;
      }
    },//eo showTopUpModal

    popGrouponModal() {
      this.showCouponModal = true;
      let __vcc = setTimeout(() =>{
        this.$refs.couponsn.focus();
        clearTimeout(__vcc);
      } , 800);
    }, // eo popGrouponModal

    popCreditCardModal() {
      this.showUpdateUserEmail = false;
      this.showCreditCardModal = true;
      this.cardnoinvalid = false;
      this.carddateinvalid = false;
      this.cardcvsinvalid = false;
      this.creditCartCheckingResult = null;
      this.cardno = '';
      this.carddate = '';
      this.cardcvs = '';
      this.showPaymentModal = false;

      const user = this.$state.$get('user');
      // console.log('user: ', user);
      const useremail = user.email && user.email.indexOf('@') !== -1 ? user.email : user.email2;

      if (!useremail) {
        this.showUpdateUserEmail = true;
      }

      let __vcc = setTimeout(() =>{
        this.$refs.cardno.focus();
        clearTimeout(__vcc);
      } , 800);
    }, // eo popCreditCardModal
    
    onDeductClick(){
        
    },//eo onDeductClick
    
    doCheckOut(action){
        let app = this;
        
        // console.info('action:', action);
        
        if(action === 1){
          if (this.device_record.price === undefined) { //device_record.price not found
            //console.info(`device_record.price not found. get_device_info()`);
            get_device_info(app, app.uuid); //Added this to fixed sometime device_record.price not find cause user use default price to pay issue.
          }

          let checkout = {
            amount: app.amount_to_pay(),
            credits: app.balance,
            bonus: app.bonus,
            after_credits: app.after_credits,
            after_bonus: app.after_bonus,
            watts: app.mqtt_value.value1,
		        all_watts: app.mqtt_value.value2,
            total_used_watts: app.total_used_watts
          };

          // console.info('checkout:', checkout); return;
            
          checkout = encodeURIComponent(config.encrypt(JSON.stringify(checkout), config.ffkey, config.ffiv));
          app.showCashCheckOutProcessing = true;
            
          app.$jsonp(`${config.mqtt_root}/checkout`, {
            user_id: encodeURIComponent(app.$state.$get('user').uuid),
  					device_id: encodeURIComponent(app.uuid),
  					keyset: 'mqtt',
  					token: app.$state.$get('user').token,
            checkout
          }).then(function(result){

            if(result.success){
            
              app.end_time           = moment().tz(config.timezone).unix();
      				app.current_used_watts = 0;
              app.current_used_watts_peak = 0;
              app.total_used_watts = 0;
      				app.current_used_time  = 0;
              
              //console.info('check out result: ', result);
              
              let _cc = setTimeout(() => {
					      // get_latest_charging_record(app);
                get_balance(app);
					      clearTimeout(_cc);
                    
                app.$jsonp(`${config.mqtt_root}/get_latest_charging_record`, {
        					user_id:   encodeURIComponent(app.$state.$get('user').uuid),
        					device_id: encodeURIComponent(app.uuid),
        					keyset: 'mqtt',
        					token: app.$state.$get('user').token
    				    }).then((charging_record) => {

        					if(charging_record.success){
        						app.start_time = charging_record.record.start_time;
        						app.end_time   = charging_record.record.end_time;

        						if(charging_record.record.status === 'end'){
        							app.record            = {};
        							app.record.used_watts = charging_record.record.used_watts;
                      app.record.used_watts_peak = charging_record.record.used_watts_peak;
        							app.record.interval   = Math.round(charging_record.record.interval/3600);
        						}
                                
                    // app.mqtt_value.value3 = 0;
        					}

                  app.showSuccess({message: '系統回歸設定值...請稍候'});

                  // window.location.reload(true);
                  setTimeout(() => {
                    app.showCashCheckOutProcessing = false;
                    app.showCashCheckOutModal = false;
                    app.showMqttErrorCheckOutModal = false;
                    console.info('reload - 4');
                    window.location.reload(true);
                  }, 6500);
    				    });
			        }, 400);
              
              app.showSuccess({message: '充電已停止'});
              // app.showCashCheckOutProcessing = false;
              // app.showCashCheckOutModal = false;
            } else {
              //console.info('result:', result);
              app.showError({message: '系統錯誤，請反應給管理人員. Detail:'+(result.error || result.message)});
              app.showCashCheckOutProcessing = false;
              app.showCashCheckOutModal = false;
              app.showMqttErrorCheckOutModal = false;

              app.showSuccess({message: '系統回歸設定值...'});

              setTimeout(() => {
                console.info('reload - 5');
                window.location.reload(true);
              }, 1500);
            }
          }).catch((error) => {
            console.info('something wrong with JSONP:', error);
            app.showCashCheckOutProcessing = false;
            app.showCashCheckOutModal = false;
            app.showMqttErrorCheckOutModal = false;
          });
        } else {
            app.showCashCheckOutModal = false;
            app.showMqttErrorCheckOutModal = false;
        }
    },
    amount_to_pay() {
        
        if(this === undefined){
          return 0;
        }
        
        let a     = 0;
        let c     = this.current_used_watts;
        let c_peak     = this.current_used_watts_peak;
        // let c     = 10;
        let price = this.price;
        let price_peak = this.price;

        if (this.device_record && (this.device_record.price !== undefined)) {
          //console.info(`Got price = `, this.device_record.price);
          price = this.device_record.price;
          price_peak = this.device_record.price_peak;
        }

        // console.info(`this.device: `, this.device_record);
        
        if(c >= 0){
            // console.info('current_used_watts:', c);
            a = Math.round(c*price + c_peak*price_peak);
            // console.info('fee:', a);
            
            let after_bonus   = this.bonus;
            let after_credits = this.balance;

            // console.info(`after_bonus:${after_bonus}, after_credits:${after_credits}`);
            
            if(true){
                // console.info('1. after_bonus:', after_bonus, ', after_bonus - a:', (after_bonus - a));
                after_bonus = this.bonus - a;
                a -= this.bonus;
                a = a <= 0 ? 0 : a;
                // console.info('2. after_bonus:', after_bonus, ', a:', (a));
            } else {
                a = Math.round((c)*price);
            }
            
            after_credits -= a;//console.info(`after_credits:${after_credits}`);

            a = after_credits;
            
            // a -= after_credits;console.info(`a:${a}`);
            
            // console.info('a:', a, ', this.deduct_bonus:', this.deduct_bonus, ', c:', c);
            
            // after_bonus = after_bonus >= 0 ? after_bonus : 0;
            // after_credits = after_credits >= 0 ? after_credits : 0;
            
            this.after_bonus = after_bonus;
            this.after_credits = after_credits; 

            if(after_bonus < 0) {
              this.final_bonus = 0;
            } else {
              this.final_bonus = after_bonus;
            }
        
            // a = a <= 0 ? 0 : a;
        }

        return Math.abs(a);
    },

    checkCoupon() {
      if (_.trim(this.couponsn) && !this.isOkayToCheckout !== null){

        this.$jsonp(`${config.mqtt_root}/validate_coupon`, {
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          device_id: encodeURIComponent(this.uuid),
          keyset: 'mqtt',
          token: this.$state.$get('user').token,
          couponsn: encodeURIComponent(config.encrypt(this.couponsn, config.ffkey, config.ffiv)),
        }).then((result) => {
          this.couponsn = '';
          if (result.success) {
            // this.couponObject = result.coupon;
            this.showSuccess({message: result.message});
            this.showCouponModal = false;

            setTimeout(() => {
              this.showSuccess({message: '刷新您的點數，請稍後'});
              console.info('reload - 6');
              window.location.reload(true);
            }, 800);
          } else {
            this.showError({message: result.message});
            this.$refs.couponsn.focus();
          }
        }).catch((error) => {
          this.couponsn = '';
          this.showError({message: error.message});
          this.$refs.couponsn.focus();
        });
      }
    }, // eo checkCoupon

    checkCreditCard() {
      const creditcard = {
        cardno: this.cardno,
        carddate: this.carddate,
        cardcvs: this.cardcvs,
        cardemail: this.cardemail,
      };

      this.cardnoinvalid = false;
      this.carddateinvalid = false;
      this.cardcvsinvalid = false;
      this.cardemailinvalid = false;
      this.creditCartCheckingResult = null;

      if (creditcard.cardno.length < 15
          || isNaN(creditcard.cardno)) {
        this.cardnoinvalid = true;
      } else if (creditcard.carddate.length < 4
                 || creditcard.carddate.indexOf('/') !== -1
                 || isNaN(creditcard.carddate)) {
        this.carddateinvalid = true;
      } else if (creditcard.cardcvs.length < 3
                 || isNaN(creditcard.cardcvs)) {
        this.cardcvsinvalid = true;
      } else if (this.showUpdateUserEmail && creditcard.cardemail.indexOf('@') === -1) {
        this.cardemailinvalid = true;
      } else {
        this.checkCreditCartProcessing = true;

        creditcard.carddate = creditcard.carddate.substr(2) + creditcard.carddate.substr(0, 2);

        this.$jsonp(`${config.mqtt_root}/validate_creditcard`, {
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          keyset: 'mqtt',
          token: this.$state.$get('user').token,
          creditcard: encodeURIComponent(config.encrypt(JSON.stringify(creditcard), config.ffkey, config.ffiv)),
        }).then((result) => {
          
          console.info('check credit card result', result);
          this.creditCartCheckingSuccess = result.success;
          this.creditCartCheckingResult = result.message + (result.rlt && result.rlt.Message ? ':' + result.rlt.Message : '');

          if (result.success) {
            this.showCreditCardModal = false;
            this.showSuccess({
              message: result.message,
            });
          }
          this.checkCreditCartProcessing = false;

          if (creditcard.cardemail) {
            const user = this.$state.$get('user');
            user.email2 = creditcard.cardemail;
            this.$state.$set('user', user);
          }

          this.available_cards = [];

        }).catch((error) => {
          // console.info('check credit card error', error);
          // this.showError(error);
          this.checkCreditCartProcessing = false;
        });

        // console.info('creditcard: ', creditcard);
      }

    }, // eo checkCreditCard

    setCreditCard(id, last4, op) {
      let msg = '';
      if(!this.mqtt_value.value3) {
        msg = op === 'delete' ? `您確定要刪除 xxxx-xxxx-xxxx-${last4} 這張信用卡嗎？`
                                  : `您確定要將 xxxx-xxxx-xxxx-${last4} 設定為扣款卡嗎？`;

        if (window.confirm(msg)) {
          
          this.$jsonp(`${config.mqtt_root}/set_creditcard`, {
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            token: this.$state.$get('user').token,
            creditcard: encodeURIComponent(config.encrypt(`${id}`, config.ffkey, config.ffiv)),
            op,
          }).then((result) => {
            this.available_cards = [];
            if (result.success) {
              this.showSuccess(result);
            } else {
              this.showError(result);  
            }
          }).catch((error) => {
            console.info('set credit card error', error);
            this.showError(error);
          });
        }

      } else {
        msg = `充電中無法刪除信用卡，請先停止充電!`;
        if (window.confirm(msg));
      }
      
    }, // eo setCreditCard

    initApplePay() {

      if (this.applePayAmount < this.minApplePayAmount) {
        this.applePayAmount = this.minApplePayAmount;
        return;
      }

      if ( !this.buyername ) {
        this.$refs.buyername.focus();
        this.showError({message: '請填入發票買受人名稱'});
        return;
      }

      if ( !this.buyeremail ) {
        this.$refs.buyeremail.focus();
        this.showError({message: '請填入發票買受人Email'});
        return;
      }

      if (this.buyerubn && this.buyerubn.length !== 8) {
        this.buyerubn = '';
        this.$refs.buyerubn.focus();
        this.showError({message: '請填入正確的統一編號'});
        return;
      }

      // console.info('all this.applePayAmount: ', this.applePayAmount);

      const amount = Math.round(this.applePayAmount * 1.15);

      const app = this;
      const request = {
       countryCode: 'TW', // 國碼
       currencyCode: 'TWD', // 交易貨幣
       supportedNetworks: ['amex', 'masterCard', 'visa'],
       merchantCapabilities: [
        'supports3DS', 'supportsEMV', 'supportsCredit', 'supportsDebit' 
      ],
      lineItems: [
        {
          "label": "Charging points",
          "type": "final",
          "amount": parseFloat(amount).toFixed(2),
        },
      ],
       total: {
          label: 'Innoknight Inc.',
          type: "final",
          amount: parseFloat(amount).toFixed(2),
        }, // amount為此次交易金額
      };
      
      /* 建立 ApplePaySession */
      /* 參數1：版本號、參數2：付款請求物件 */
      const session = new ApplePaySession(1, request);
      session.onvalidatemerchant = function (event) {

        // console.info('session.onvalidatemerchant.event: ', event);
       
        const data = {
          validationURL: event.validationURL,
          hostname: window.location.host,
        };

        app.$jsonp(`${config.mqtt_root}/verify_applepay`, {
          user_id:   encodeURIComponent(app.$state.$get('user').uuid),
          device_id: encodeURIComponent(app.uuid),
          keyset: 'mqtt',
          token: app.$state.$get('user').token,
          data: JSON.stringify(data)
        }).then((verificationObject) => {
          // console.info('session: ', JSON.parse(verificationObject.session));
          if (verificationObject && verificationObject.success) {
            try {
              // console.info('window.location.host: ', window.location.host);
              const rlt = session.completeMerchantValidation(JSON.parse(verificationObject.session));
            } catch (error) {
              console.info('apple pay error: ', error);
              session.abort();
            }
          }
        });
      };

      session.oncancel = function(event) {
        console.info('apple pay canceled: ', event);
      }

      // session.onpaymentmethodselected = function(event) {
      //   console.info('starting session.onpaymentmethodselected');
      //   console.info(event);
        
      //   var newTotal = { type: 'final', label: '<?=PRODUCTION_DISPLAYNAME?>', amount: runningTotal() };
      //   var newLineItems =[{type: 'final',label: subTotalDescr, amount: runningAmount }, {type: 'final',label: 'P&P', amount: runningPP }];
        
      //   session.completePaymentMethodSelection( newTotal, newLineItems );
      // }

      session.onpaymentauthorized = function (event) {
        
        // const data = {
        //   payment: JSON.stringify(event.payment),
        // };

        // console.info('onpaymentauthorized: ', data);

        app.$jsonp(`${config.mqtt_root}/auth_applepay_test`, {
          user_id:   encodeURIComponent(app.$state.$get('user').uuid),
          device_id: encodeURIComponent(app.uuid),
          keyset: 'mqtt',
          token: app.$state.$get('user').token,
          data: JSON.stringify(event.payment),
          amount: amount,
          buyername:app.buyername,
          buyerubn: app.buyerubn,
          buyeremail: app.buyeremail,
        }).then((authObject) => {
          console.info('authObject: ', authObject);
          if (authObject && authObject.success) {
            session.completePayment(JSON.parse(ApplePaySession.STATUS_SUCCESS));
            app.showSuccess({message:'交易成功'});
            app.showTopUpModal = false;
          } else {
            session.completePayment(JSON.parse(ApplePaySession.STATUS_FAILURE));
            app.showError({message:'暫時無法加值，請稍後再試'});
            app.showTopUpModal = false;
          }
        });

        /* 將payment物件拋至Server端，由Server端處理交易授權 */
        // $.ajax({
        //   url: ' Your Server URL',
        //   method: "POST",
        //   contentType: "application/json; charset=utf-8",
        //   data: JSON.stringify(data),
        //   error: function (err) {
        //     alert(JSON.stringify(err));
        //   }
        // }).then(function (result) {
        //   /* 依授權結果決定帶入ApplePaySession的回應 */
        //   // 授權成功
        //   session.completePayment(JSON.parse(ApplePaySession.STATUS_SUCCESS));
        //   // 授權失敗
        //   session.completePayment(JSON.parse(ApplePaySession.STATUS_FAILURE));
        // });
      }

      session.begin();
    }, // eo initApplePay
	},//eo methods
}
</script>

<style>
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
#qrcode-window { max-height: 400px; margin: auto; display: block; max-width: 100%;}
#qrcode-window video { max-width: 100%; }
#qrcode-video { max-width: 100%; }
.app{
  background: black;
}
.status-li{
	color: white; margin: 0.5rem 0; 
	font-weight: bold;
	font-size: 1.5rem;
	padding-left: 1rem;
}
.grecaptcha-badge{
	display: none !important;
}
.li-icon{
	padding: 0px;
	margin: 0px;
	width: 10%;
	max-width: 30px;
}
.li-text {
	width: 90%;
}
.main-body{
	max-width: 450px;
	margin: auto;
}
.top-up-btn{
  height: 5rem;
  max-width: 98%;
  min-width: 98%;
  font-size: 2rem;
  margin: 0.5px 0px;
}
.select-payment-btn{
  height: 3.5rem;
  max-width: 98%;
  min-width: 98%;
  font-size: 1.2rem;
  text-align: center;
  margin: 0.5px 0px;
}
.select-payment-img{
  display: inline;
  height: 3rem;
  text-align: center;
  margin-top: -0.25rem;
}
.fixed-leading{
  display: inline-block;
  width: 1.3rem;
  text-align: center;
}
.lame-btn {
  border: none !important;
  background-color: transparent !important;
}
.lg-icon-btn {
  font-size: 2.1rem;
}
Supports (-webkit-appearance: -apple-pay-button) {
 .apple-pay-button {
 display: inline-block;
 -webkit-appearance: -apple-pay-button;
 }
 .apple-pay-button-white {
   -apple-pay-button-style: white;
 }
}
supports not (-webkit-appearance: -apple-pay-button) {
 .apple-pay-button {
 display: inline-block;
 background-size: 100% 60%;
 background-repeat: no-repeat;
 background-position: 50% 50%;
 border-radius: 5px;
 padding: 0px;
 box-sizing: border-box;
 min-width: 200px;
 min-height: 32px;
 max-height: 64px;
 }
 .apple-pay-button-white {
   background-image: -webkit-named-image(apple-pay-logo-black);
   background-color: white;
 }
}
#btnApplePay{
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: buy;
  -apple-pay-button-style: white;
  height: 3.5rem;
  width: 100%;
}
.apple-pay-amount {
  padding-top: .65rem;
  font-size: 1.2rem;
}
.action-btn-container {
  padding: 0 !important;
}
.battery-icon {
  font-size: 21rem;
  display: block;
  color: white;
  margin: auto;
}
.battery-icon-charging {
  font-size: 21rem;
  display: block;
  color: white;
  margin: auto;
  -moz-animation:myfirst 5s infinite; /* Firefox */
  -webkit-animation:myfirst 5s infinite; /* Safari and Chrome */
}
@media screen and (max-width: 480px) {
  .battery-icon {
    font-size: 66vw;
  }
  .battery-icon-charging {
    font-size: 66vw;
  }
  .card-header {
    padding: .75rem .2rem;
  }
}
@-moz-keyframes myfirst /* Firefox */ {
  0% {color:blue;}
  50% {color:yellow;}
  100% {color:white;}
}

@-webkit-keyframes myfirst /* Safari and Chrome */ {
  0% {color:blue;}
  50% {color:yellow;}
  100% {color:white;}
}
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />